// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25k-Y","footer":"Form_footer__Hxw8D"};